"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJdhPage = exports.getSeoTitle = exports.getSeoTitles = exports.getSeoMetaRouterLine = exports.HTMLDecode = exports.appBaseName = void 0;
var seoLocationWatcher_1 = require("./seoLocationWatcher");
exports.appBaseName = "/s"; // 要和上边注释的一致，由于异步问题，上边的数据可能开始为空
function HTMLDecode(text) {
    var demo = document.createElement("div");
    demo.innerHTML = text;
    var outPutText = demo.innerText || demo.textContent;
    demo = null;
    return outPutText;
}
exports.HTMLDecode = HTMLDecode;
function getSeoMetaRouterLine() {
    var routerMetas = document.querySelectorAll("meta[name=route]");
    var routerMetasArr = Array.from(routerMetas);
    var queryMetas = document.querySelectorAll("meta[name=query]");
    var queryMetasArr = Array.from(queryMetas);
    var queryParams = {};
    queryMetasArr.forEach(function (queryMeta) {
        var queryContent = queryMeta.getAttribute("content") || "";
        if (!queryContent) {
            return;
        }
        queryContent = HTMLDecode(queryContent);
        var queryParamArr = queryContent.split("&");
        if (!queryParamArr || queryParamArr.length === 0) {
            return;
        }
        queryParamArr.forEach(function (queryParam) {
            var queryParamItem = queryParam.split("=");
            var queryParamKey = queryParamItem[0];
            var queryParamVal = queryParamItem[1] || "";
            if (queryParamKey) {
                // @ts-ignore
                queryParams[queryParamKey] = queryParamVal;
            }
        });
    });
    var metaRouterLine = [];
    routerMetasArr.forEach(function (routerMeta) {
        var source = routerMeta.getAttribute("source");
        var seo = routerMeta.getAttribute("seo");
        if (source && seo) {
            var realSourcePath = (function () {
                if (exports.appBaseName && source.startsWith(exports.appBaseName)) {
                    return source.replace(exports.appBaseName, "");
                }
                return source;
            })();
            metaRouterLine.push({
                source: realSourcePath,
                seo: seo,
                query: queryParams,
            });
        }
    });
    return metaRouterLine;
}
exports.getSeoMetaRouterLine = getSeoMetaRouterLine;
function getSeoTitles() {
    var titleMetas = document.querySelectorAll("meta[name=seoTitle]");
    var titleMetasArr = Array.from(titleMetas);
    var titles = [];
    titleMetasArr.forEach(function (titleMeta) {
        var titleContent = titleMeta.getAttribute("content") || "";
        var titleRoute = titleMeta.getAttribute("route") || "";
        if (titleContent && titleRoute) {
            titles.push({
                title: titleContent,
                pathName: titleRoute,
            });
        }
    });
    return titles;
}
exports.getSeoTitles = getSeoTitles;
function getSeoTitle() {
    // @ts-ignore
    var wd = window || global;
    var currentPath = wd.location.pathname;
    var seoTitles = getSeoTitles();
    var seoTitleConfig = seoTitles.find(function (item) {
        return item.pathName === currentPath;
    });
    return seoTitleConfig && seoTitleConfig.title;
}
exports.getSeoTitle = getSeoTitle;
function isJdhPage(host) {
    var res = (0, seoLocationWatcher_1.checkIsSeoPage)(host);
    return res.isJdh || res.isContJd;
}
exports.isJdhPage = isJdhPage;
